<br>
<div *ngIf="enableLoader" id="loader"></div>
<div class="text-center strong  text-primary mb-5" *ngIf="showNotAvailableMsg"> {{'common.noData' | cxTranslate}}</div>

<div *ngIf="productData && grid && !showNotAvailableMsg && !enableLoader ">
  <div class="search-results" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
  (scrolled)="onScrollGrid()"  [scrollWindow]="true">
  <!-- <div *ngFor="let item of productData.products,let i = index">
    <app-custom-product-carousel *ngIf="item.ports.length>0" [browseType]=browseType [item]=item [index]=index>
    </app-custom-product-carousel>
  </div> -->
  <div *ngFor="let item of productData | keyvalue,let i = index">
    <app-custom-product-carousel [browseType]=browseType [item]=item.value [index]=index>
       </app-custom-product-carousel>
     </div>
  </div>
  <div *ngIf="loaderShow" id="loader"></div>
  <!-- <div  class="text-center strong  text-primary mb-3" *ngIf = "reachedToEnd" >  {{ "home.contracts.Nomore" | cxTranslate }}</div> -->
</div>
  <div class="container">
    <div *ngIf="list && !showNotAvailableMsg && !enableLoader">
      <div class="search-results" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
      (scrolled)="onScroll()" [scrollWindow]="true">
      <div *ngFor="let item of productData | keyvalue,let i = i">
        <app-products-list-view  [browseType]=browseType [item]=item.value [index]=i>
        </app-products-list-view>
      </div>
    </div>
    <div *ngIf="loaderShow" id="loader"></div>

  </div>
</div>
<!-- 
<div class="container">
  <div *ngIf="list && !showNotAvailableMsg && !enableLoader">
    <div class="search-results" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
    (scrolled)="onScroll()" [scrollWindow]="true">
    <div *ngFor="let listItem of productData.products,let i = i">
      <app-products-list-view *ngIf="listItem.ports.length>0" [browseType]=browseType [item]=listItem [index]=i>
      </app-products-list-view>
    </div>
  </div>
  <div *ngIf="loaderShow" id="loader"></div>

</div>
</div> -->
